import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getBackendUrl = () => BACKEND_URL;

// Get the correct base URL for static assets (logos, uploads, etc.)
// Uses current origin in production to avoid cross-domain issues
export const getAssetBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.origin;
  }
  return BACKEND_URL;
};

// Helper to get full URL for uploaded assets
export const getAssetUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${getAssetBaseUrl()}${path}`;
};

// Format salary display based on salary_type
export const formatSalary = (job) => {
  const salaryType = job?.salary_type;
  const minSalary = job?.min_salary || 0;
  const maxSalary = job?.max_salary || 0;
  
  if (salaryType === 'as_per_norms') {
    return minSalary > 0 ? `₹${minSalary.toLocaleString()} - As Per Norms` : 'As Per Norms';
  }
  if (salaryType === 'as_per_experience') {
    return minSalary > 0 ? `₹${minSalary.toLocaleString()} - As Per Experience` : 'As Per Experience';
  }
  // Default numeric display
  if (minSalary > 0 && maxSalary > 0) {
    return `₹${minSalary.toLocaleString()} - ₹${maxSalary.toLocaleString()}`;
  }
  if (minSalary > 0) {
    return `₹${minSalary.toLocaleString()}+`;
  }
  return 'Not Specified';
};

export default api;